export default {"src":"/_next/static/media/instagram-logo.c422bd20.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};